<div
  class="card card-md border-0 available-account-balance fund-account
  {{ isLoading ? 'skeleton-loader' : 'loaded' }}
  {{ isEmployeeCardBalance() ? 'bg-secondary-subtle' : 'bg-secondary' }}"
  [ngClass]="{ 'text-white': !isEmployeeCardBalance() }">
  <div class="card-body align-content-center">
    <div class="row">
      <div class="col-auto">
        <div
          class="icon-rounded bg-white"
          [ngClass]="{ 'loading': isLoading, 'text-secondary': !isEmployeeCardBalance() }">
          @if (isEmployeeCardBalance()) {
            <i class="pays-svg-icon ic-card-app"></i>
          } @else {
            <i class="pays-svg-icon ic-card-2"></i>
          }
        </div>
      </div>
      <div class="col">
        <div>
          <div
            class="badge rounded-pill mb-1 {{ isEmployeeCardBalance() ? 'bg-dark' : 'bg-white text-dark' }}"
            [class.loading]="isLoading">
            {{ isEmployeeCardBalance() ? 'Employee' : 'Subscription' }} cards
          </div>
        </div>
        <div>
          <div
            class="fw-medium title"
            [class.loading]="isLoading">
            Available account balance
          </div>
        </div>
        <div>
          @if (isEmployeeCardBalance()) {
            <div
              class="amounts"
              id="employeeCardBalance"
              [ngClass]="{ 'loading min-w-100': isLoading }">
              {{ accountBalance()?.balance_physical | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
            </div>
            @if (accountBalance()?.balance_physical === '0.00') {
              <ng-container [ngTemplateOutlet]="noBalanceAlert"></ng-container>
            }
          } @else {
            <span
              class="amounts"
              id="subCardBalance"
              [ngClass]="{ 'loading min-w-100': isLoading }">
              {{ accountBalance()?.balance_virtual | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
            </span>
            @if (accountBalance()?.balance_virtual === '0.00') {
              <ng-container [ngTemplateOutlet]="noBalanceAlert"></ng-container>
            }
          }
        </div>
        <ng-template #noBalanceAlert>
          <br />
          <div class="alert warning-emphasis mt-1 d-inline-block mb-0">
            <div class="row align-items-center">
              <div class="col-auto pe-0">
                <i class="iconoir-warning-triangle"></i>
              </div>
              <div class="col small">
                @if (isEmployeeCardBalance()) {
                  Fund your physical employee cards here.
                } @else {
                  Fund your virtual subscription cards here.
                }
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="col-auto align-self-center">
        <div class="collapse-arrow">
          <!-- wording added via css -->
          <div class="btn btn-light">&nbsp;account <i class="iconoir-nav-arrow-right"></i></div>
        </div>
      </div>
    </div>
  </div>
</div>
